import { Injectable } from '@angular/core';
import { nameof, TwoWayAdapter, IModelMetadata } from '@bds/core';
import { FormGroupDescription, GridColumnDescription, IColumnDescription } from './adapter_t';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

export class RtvTripError {
    constructor(
        public carInit: string,
        public carNo: string,
        public shipDateTime: Date,
        public custNo: string,
        public importCustNo: string,
        public importCustName: string,
        public routeCode: string,
        public importRouteCode: string,
        public importRouteDscr: string,
        public tripNo: string,
        public origCity: string,
        public origState: string,
        public origSplc: string,
        public destCity: string,
        public destState: string,
        public destSplc: string,
        public releaseCity: string,
        public releaseState: string,
        public returnCity: string,
        public returnState: string,
        public carType: string,
        public tripCommCode: string,
        public fleetId: string,
        public origEdaEtaCust: Date,
        public origEdaEtaOrigin: Date,
        public badOrderDays: number,
        public carCondition: string,
        public carStatus: string,
        public tripStatus: string,
        public sightCode: string,
        public clmDateTime: Date,
        public locCity: string,
        public locState: string,
        public le: string,
        public road: string,
        public destArrDateTime: Date,
        public destArrType: string,
        public custDlvDateTime: Date,
        public custDlvType: string,
        public custRelDateTime: Date,
        public custRelType: string,
        public tripClsDateTime: Date,
        public tripClsType: string,
        public businessGroup: string,
        public divertYorn: string,
        public shopMove: string,
        public oneWayRound: string,
        public procDateTime: Date,
        public errorDescription: string,
        public freeRunner: string,
        public supplierShipment: string,
        public prevTripCloseDateTime: Date,
        public freightPmtCode: string,
        public shipmentType: string,
        public bolNo: string,
        public shipperNo: string,
        public custPoNo: string,
        public rqstDlvDateTime: Date,
        public supplierCode: string,
        public supplierName: string,
        public csrNo: string,
        public originalEtaToCust: Date,
        public originalEtaToOrigin: Date,
        public unitTrainId: string,
        public tripRef1: string,
        public tripRef2: string,
        public tripRef3: string,
        public tripRef4: string,
        public routeDscr: string,
        public dlvRoad: string,
        public origRoad: string,
        public truckDlv: string,
        public salesRep: string,
        public importSource: string,
        public ormId: number,
        public userId: string,
        public updateDateTime: Date,
        public tripRef5: string,
        public tripRef6: string,
        public commName: string,
        public commCode: string,
        public entryDate: Date,
        public transactionType: string,
    ) {}
    from(trip: RtvTripError): RtvTripError {
        Object.keys(trip).forEach((k) => (this[k] = trip[k]));
        return this;
    }
}

export const relationship: IModelMetadata[] = [
    { client: nameof<RtvTripError>('carInit'), server: 'carInit' },
    { client: nameof<RtvTripError>('carNo'), server: 'carNo' },
    { client: nameof<RtvTripError>('shipDateTime'), server: 'shipDateTime' },
    { client: nameof<RtvTripError>('custNo'), server: 'custNo' },
    { client: nameof<RtvTripError>('importCustNo'), server: 'importCustNo' },
    { client: nameof<RtvTripError>('importCustName'), server: 'importCustName' },
    { client: nameof<RtvTripError>('routeCode'), server: 'routeCode' },
    { client: nameof<RtvTripError>('importRouteCode'), server: 'importRouteCode' },
    { client: nameof<RtvTripError>('importRouteDscr'), server: 'importRouteDscr' },
    { client: nameof<RtvTripError>('tripNo'), server: 'tripNo' },
    { client: nameof<RtvTripError>('origCity'), server: 'origCity' },
    { client: nameof<RtvTripError>('origState'), server: 'origState' },
    { client: nameof<RtvTripError>('origSplc'), server: 'origSplc' },
    { client: nameof<RtvTripError>('destCity'), server: 'destCity' },
    { client: nameof<RtvTripError>('destState'), server: 'destState' },
    { client: nameof<RtvTripError>('destSplc'), server: 'destSplc' },
    { client: nameof<RtvTripError>('releaseCity'), server: 'releaseCity' },
    { client: nameof<RtvTripError>('releaseState'), server: 'releaseState' },
    { client: nameof<RtvTripError>('returnCity'), server: 'returnCity' },
    { client: nameof<RtvTripError>('returnState'), server: 'returnState' },
    { client: nameof<RtvTripError>('carType'), server: 'carType' },
    { client: nameof<RtvTripError>('tripCommCode'), server: 'tripCommCode' },
    { client: nameof<RtvTripError>('fleetId'), server: 'fleetId' },
    { client: nameof<RtvTripError>('origEdaEtaCust'), server: 'origEdaEtaCust' },
    { client: nameof<RtvTripError>('origEdaEtaOrigin'), server: 'origEdaEtaOrigin' },
    { client: nameof<RtvTripError>('badOrderDays'), server: 'badOrderDays' },
    { client: nameof<RtvTripError>('carCondition'), server: 'carCondition' },
    { client: nameof<RtvTripError>('carStatus'), server: 'carStatus' },
    { client: nameof<RtvTripError>('tripStatus'), server: 'tripStatus' },
    { client: nameof<RtvTripError>('sightCode'), server: 'sightCode' },
    { client: nameof<RtvTripError>('clmDateTime'), server: 'clmDateTime' },
    { client: nameof<RtvTripError>('locCity'), server: 'locCity' },
    { client: nameof<RtvTripError>('locState'), server: 'locState' },
    { client: nameof<RtvTripError>('le'), server: 'le' },
    { client: nameof<RtvTripError>('road'), server: 'road' },
    { client: nameof<RtvTripError>('destArrDateTime'), server: 'destArrDateTime' },
    { client: nameof<RtvTripError>('destArrType'), server: 'destArrType' },
    { client: nameof<RtvTripError>('custDlvDateTime'), server: 'custDlvDateTime' },
    { client: nameof<RtvTripError>('custDlvType'), server: 'custDlvType' },
    { client: nameof<RtvTripError>('custRelDateTime'), server: 'custRelDateTime' },
    { client: nameof<RtvTripError>('custRelType'), server: 'custRelType' },
    { client: nameof<RtvTripError>('tripClsDateTime'), server: 'tripClsDateTime' },
    { client: nameof<RtvTripError>('tripClsType'), server: 'tripClsType' },
    { client: nameof<RtvTripError>('businessGroup'), server: 'businessGroup' },
    { client: nameof<RtvTripError>('divertYorn'), server: 'divertYorn' },
    { client: nameof<RtvTripError>('shopMove'), server: 'shopMove' },
    { client: nameof<RtvTripError>('oneWayRound'), server: 'oneWayRound' },
    { client: nameof<RtvTripError>('procDateTime'), server: 'procDateTime' },
    { client: nameof<RtvTripError>('errorDescription'), server: 'errorDescription' },
    { client: nameof<RtvTripError>('freeRunner'), server: 'freeRunner' },
    { client: nameof<RtvTripError>('supplierShipment'), server: 'supplierShipment' },
    { client: nameof<RtvTripError>('prevTripCloseDateTime'), server: 'prevTripCloseDateTime' },
    { client: nameof<RtvTripError>('freightPmtCode'), server: 'freightPmtCode' },
    { client: nameof<RtvTripError>('shipmentType'), server: 'shipmentType' },
    { client: nameof<RtvTripError>('bolNo'), server: 'bolNo' },
    { client: nameof<RtvTripError>('shipperNo'), server: 'shipperNo' },
    { client: nameof<RtvTripError>('custPoNo'), server: 'custPoNo' },
    { client: nameof<RtvTripError>('rqstDlvDateTime'), server: 'rqstDlvDateTime' },
    { client: nameof<RtvTripError>('supplierCode'), server: 'supplierCode' },
    { client: nameof<RtvTripError>('supplierName'), server: 'supplierName' },
    { client: nameof<RtvTripError>('csrNo'), server: 'csrNo' },
    { client: nameof<RtvTripError>('originalEtaToCust'), server: 'originalEtaToCust' },
    { client: nameof<RtvTripError>('originalEtaToOrigin'), server: 'originalEtaToOrigin' },
    { client: nameof<RtvTripError>('unitTrainId'), server: 'unitTrainId' },
    { client: nameof<RtvTripError>('tripRef1'), server: 'tripRef1' },
    { client: nameof<RtvTripError>('tripRef2'), server: 'tripRef2' },
    { client: nameof<RtvTripError>('tripRef3'), server: 'tripRef3' },
    { client: nameof<RtvTripError>('tripRef4'), server: 'tripRef4' },
    { client: nameof<RtvTripError>('routeDscr'), server: 'routeDscr' },
    { client: nameof<RtvTripError>('dlvRoad'), server: 'dlvRoad' },
    { client: nameof<RtvTripError>('origRoad'), server: 'origRoad' },
    { client: nameof<RtvTripError>('truckDlv'), server: 'truckDlv' },
    { client: nameof<RtvTripError>('salesRep'), server: 'salesRep' },
    { client: nameof<RtvTripError>('importSource'), server: 'importSource' },
    { client: nameof<RtvTripError>('ormId'), server: 'ormId' },
    { client: nameof<RtvTripError>('userId'), server: 'userId' },
    { client: nameof<RtvTripError>('updateDateTime'), server: 'updateDateTime' },
    { client: nameof<RtvTripError>('tripRef5'), server: 'tripRef5' },
    { client: nameof<RtvTripError>('tripRef6'), server: 'tripRef6' },
    { client: nameof<RtvTripError>('commName'), server: 'commName' },
    { client: nameof<RtvTripError>('commCode'), server: 'commCode' },
    { client: nameof<RtvTripError>('entryDate'), server: 'entryDate' },
    { client: nameof<RtvTripError>('transactionType'), server: 'transactionType' },
];

@Injectable({
    providedIn: 'root',
})
export class RtvTripErrorAdapter extends TwoWayAdapter<RtvTripError> {
    constructor() {
        super();
    }
    public metadata: IModelMetadata[] = relationship;
}
@Injectable({
    providedIn: 'root',
})
export class RtvTripErrorMetadata implements GridColumnDescription, FormGroupDescription {
    constructor() {}
    getColumns(defaultVisibility: boolean = true): IColumnDescription[] {
        const columns = [
            {
                dataField: nameof<RtvTripError>('carInit'),
                dataType: 'string',
                caption: 'Car Init',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('carNo'),
                dataType: 'string',
                caption: 'Car Number',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('shipDateTime'),
                dataType: 'datetime',
                caption: 'Shipment Date',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: 'customerNo',
                dataType: 'string',
                caption: 'Cust Number',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('routeCode'),
                dataType: 'string',
                caption: 'routecode',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripNo'),
                dataType: 'string',
                caption: 'tripno',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('origCity'),
                dataType: 'string',
                caption: 'origincity',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('origState'),
                dataType: 'string',
                caption: 'originstate',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('destCity'),
                dataType: 'string',
                caption: 'destinationcity',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('destState'),
                dataType: 'string',
                caption: 'destinationstate',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('releaseCity'),
                dataType: 'string',
                caption: 'releasecity',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('releaseState'),
                dataType: 'string',
                caption: 'releasestate',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('returnCity'),
                dataType: 'string',
                caption: 'returncity',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('returnState'),
                dataType: 'string',
                caption: 'returnstate',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('carType'),
                dataType: 'string',
                caption: 'cartype',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripCommCode'),
                dataType: 'string',
                caption: 'tripCommCode',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('fleetId'),
                dataType: 'string',
                caption: 'fleetid',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('origEdaEtaCust'),
                dataType: 'datetime',
                caption: 'origedaetacustomer',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('origEdaEtaOrigin'),
                dataType: 'datetime',
                caption: 'origedaetaorigin',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('badOrderDays'),
                dataType: 'number',
                caption: 'badorderdays',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('carCondition'),
                dataType: 'string',
                caption: 'carcondition',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('carStatus'),
                dataType: 'string',
                caption: 'carstatus',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripStatus'),
                dataType: 'string',
                caption: 'tripstatus',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('sightCode'),
                dataType: 'string',
                caption: 'sightcode',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('clmDateTime'),
                dataType: 'datetime',
                caption: 'clmdatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('locCity'),
                dataType: 'string',
                caption: 'locationcity',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('locState'),
                dataType: 'string',
                caption: 'locationstate',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('le'),
                dataType: 'string',
                caption: 'loadempty',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('road'),
                dataType: 'string',
                caption: 'road',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('destArrDateTime'),
                dataType: 'datetime',
                caption: 'destinationarrdatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('destArrType'),
                dataType: 'string',
                caption: 'destinationarrtype',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('custDlvDateTime'),
                dataType: 'datetime',
                caption: 'customerdeliverydatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('custDlvType'),
                dataType: 'string',
                caption: 'customerdeliverytype',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('custRelDateTime'),
                dataType: 'datetime',
                caption: 'customerreleasedatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('custRelType'),
                dataType: 'string',
                caption: 'customerreleasetype',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripClsDateTime'),
                dataType: 'datetime',
                caption: 'tripclosedatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripClsType'),
                dataType: 'string',
                caption: 'tripclosetype',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('businessGroup'),
                dataType: 'string',
                caption: 'businessgroup',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('divertYorn'),
                dataType: 'string',
                caption: 'divertyorn',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('shopMove'),
                dataType: 'string',
                caption: 'shopmove',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('oneWayRound'),
                dataType: 'string',
                caption: 'onewayround',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('procDateTime'),
                dataType: 'datetime',
                caption: 'procdatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('freeRunner'),
                dataType: 'string',
                caption: 'freerunner',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('supplierShipment'),
                dataType: 'string',
                caption: 'suppliershipment',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('prevTripCloseDateTime'),
                dataType: 'datetime',
                caption: 'previoustripclosedatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('freightPmtCode'),
                dataType: 'string',
                caption: 'freightpmtcode',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('shipmentType'),
                dataType: 'string',
                caption: 'shipmenttype',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('bolNo'),
                dataType: 'string',
                caption: 'bolno',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('shipperNo'),
                dataType: 'string',
                caption: 'shipperno',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('custPoNo'),
                dataType: 'string',
                caption: 'custPoNo',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('rqstDlvDateTime'),
                dataType: 'datetime',
                caption: 'rqstdlvdatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('supplierCode'),
                dataType: 'string',
                caption: 'suppliercode',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('supplierName'),
                dataType: 'string',
                caption: 'suppliername',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('csrNo'),
                dataType: 'string',
                caption: 'csrno',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('originalEtaToCust'),
                dataType: 'datetime',
                caption: 'originaletatocust',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('originalEtaToOrigin'),
                dataType: 'datetime',
                caption: 'originaletatoorigin',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('unitTrainId'),
                dataType: 'string',
                caption: 'unittrainid',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripRef1'),
                dataType: 'string',
                caption: 'tripref1',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripRef2'),
                dataType: 'string',
                caption: 'tripref2',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripRef3'),
                dataType: 'string',
                caption: 'tripref3',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripRef4'),
                dataType: 'string',
                caption: 'tripref4',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripRef5'),
                dataType: 'string',
                caption: 'tripref5',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('tripRef6'),
                dataType: 'string',
                caption: 'tripref6',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('routeDscr'),
                dataType: 'string',
                caption: 'routedscr',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('dlvRoad'),
                dataType: 'string',
                caption: 'dlvroad',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('origRoad'),
                dataType: 'string',
                caption: 'origroad',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('truckDlv'),
                dataType: 'string',
                caption: 'truckdlv',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('salesRep'),
                dataType: 'string',
                caption: 'salesrep',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('importSource'),
                dataType: 'string',
                caption: 'importsource',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('ormId'),
                dataType: 'number',
                caption: 'ormid',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('userId'),
                dataType: 'string',
                caption: 'userid',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('updateDateTime'),
                dataType: 'datetime',
                caption: 'updatedatetime',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('commName'),
                dataType: 'string',
                caption: 'commname',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('commCode'),
                dataType: 'string',
                caption: 'commcode',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('errorDescription'),
                dataType: 'string',
                caption: 'errorDescription',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('transactionType'),
                dataType: 'string',
                caption: 'transactionType',
                visible: !defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvTripError>('entryDate'),
                dataType: 'datetime',
                caption: 'entryDate',
                visible: !defaultVisibility,
            } as IColumnDescription,
        ];
        return columns;
    }

    getFormGroup(obj?: any): UntypedFormGroup {
        const formGroup = new UntypedFormGroup({});
        formGroup.addControl(nameof<RtvTripError>('carInit'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('carNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('shipDateTime'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('custNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('routeCode'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('origCity'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('origState'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('destCity'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('destState'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('releaseCity'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('releaseState'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('returnCity'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('returnState'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('carType'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripCommCode'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('fleetId'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('origEdaEtaCust'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('origEdaEtaOrigin'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('badOrderDays'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('carCondition'), new UntypedFormControl(''));
        formGroup.addControl(
            nameof<RtvTripError>('carStatus'),
            new UntypedFormControl({ value: '', disabled: true }),
        );
        formGroup.addControl(nameof<RtvTripError>('tripStatus'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('sightCode'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('clmDateTime'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('locCity'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('locState'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('le'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('road'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('destArrDateTime'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('destArrType'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('custDlvDateTime'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('custDlvType'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('custRelDateTime'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('custRelType'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripClsDateTime'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripClsType'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('businessGroup'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('divertYorn'), new UntypedFormControl(''));
        formGroup.addControl(
            nameof<RtvTripError>('shopMove'),
            new UntypedFormControl({ value: '', disabled: true }),
        );
        formGroup.addControl(
            nameof<RtvTripError>('oneWayRound'),
            new UntypedFormControl({ value: '', disabled: true }),
        );
        formGroup.addControl(nameof<RtvTripError>('procDateTime'), new UntypedFormControl(''));
        formGroup.addControl(
            nameof<RtvTripError>('freeRunner'),
            new UntypedFormControl({ value: '', disabled: true }),
        );
        formGroup.addControl(
            nameof<RtvTripError>('supplierShipment'),
            new UntypedFormControl({ value: '', disabled: true }),
        );
        formGroup.addControl(
            nameof<RtvTripError>('prevTripCloseDateTime'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(nameof<RtvTripError>('freightPmtCode'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('shipmentType'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('bolNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('shipperNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('custPoNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('rqstDlvDateTime'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('supplierCode'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('supplierName'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('csrNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('originalEtaToCust'), new UntypedFormControl(''));
        formGroup.addControl(
            nameof<RtvTripError>('originalEtaToOrigin'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(nameof<RtvTripError>('unitTrainId'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripRef1'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripRef2'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripRef3'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripRef4'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('routeDscr'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('dlvRoad'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('origRoad'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('truckDlv'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('salesRep'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('importSource'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('ormId'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('userId'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('updateDateTime'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripRef5'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('tripRef6'), new UntypedFormControl(''));

        formGroup.addControl(nameof<RtvTripError>('commName'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('commCode'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('errorDescription'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('transactionType'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvTripError>('entryDate'), new UntypedFormControl(''));

        if (!!obj) {
            formGroup.setValue(obj);
        }

        this.setValidators(formGroup);
        return formGroup;
    }

    setValidators(form: UntypedFormGroup, isLoadAndHold?: boolean, ormId?: number): void {
        const requiredValidator = (isLoadAndHold && ormId) || ormId ? [Validators.required] : [];
        const standardValidators = isLoadAndHold ? [] : [Validators.required];

        form.controls[nameof<RtvTripError>('carInit')].setValidators([
            Validators.required,
            Validators.maxLength(4),
        ]);
        form.controls[nameof<RtvTripError>('carNo')].setValidators([
            Validators.required,
            Validators.maxLength(6),
        ]);
        form.controls[nameof<RtvTripError>('bolNo')].setValidators([Validators.maxLength(80)]);
        form.controls[nameof<RtvTripError>('supplierName')].setValidators([
            Validators.maxLength(30),
        ]);
        form.controls[nameof<RtvTripError>('unitTrainId')].setValidators([
            Validators.maxLength(15),
        ]);
        form.controls[nameof<RtvTripError>('shipperNo')].setValidators([Validators.maxLength(13)]);
        form.controls[nameof<RtvTripError>('tripRef1')].setValidators([Validators.maxLength(20)]);
        form.controls[nameof<RtvTripError>('tripRef2')].setValidators([Validators.maxLength(20)]);
        form.controls[nameof<RtvTripError>('tripRef3')].setValidators([Validators.maxLength(20)]);
        form.controls[nameof<RtvTripError>('tripRef4')].setValidators([Validators.maxLength(20)]);
        form.controls[nameof<RtvTripError>('tripRef5')].setValidators([Validators.maxLength(25)]);
        form.controls[nameof<RtvTripError>('tripRef6')].setValidators([Validators.maxLength(25)]);
        form.controls[nameof<RtvTripError>('shipDateTime')].setValidators([Validators.required]);
        form.controls[nameof<RtvTripError>('origCity')].setValidators(
            isLoadAndHold
                ? [Validators.required, Validators.maxLength(9)]
                : [Validators.maxLength(9)],
        );
        form.controls[nameof<RtvTripError>('origState')].setValidators(
            isLoadAndHold ? [Validators.required] : [],
        );

        form.controls[nameof<RtvTripError>('custNo')].setValidators([
            ...standardValidators,
            Validators.maxLength(13),
        ]);

        form.controls[nameof<RtvTripError>('carInit')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('carNo')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('shipDateTime')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('origCity')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('origState')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('routeCode')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('custNo')].updateValueAndValidity();

        form.controls[nameof<RtvTripError>('bolNo')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('supplierName')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('unitTrainId')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('shipperNo')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('tripRef1')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('tripRef2')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('tripRef3')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('tripRef4')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('tripRef5')].updateValueAndValidity();
        form.controls[nameof<RtvTripError>('tripRef6')].updateValueAndValidity();
    }
}
